(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const playButtons = document.querySelectorAll(".grid-play-button");
  const popup = document.getElementById("gridVideoPopup");
  const videoContainer = document.getElementById("gridVideoContainer");
  const closeBtn = document.querySelector(".grid-video-popup .grid-close-btn");

  playButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const videoUrl = btn.getAttribute("data-video");
      let embedHtml = "";

      if (videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be")) {
        embedHtml = `<iframe src="${videoUrl.replace("watch?v=", "embed/")}?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
      } else if (videoUrl.includes("vimeo.com")) {
        const vimeoId = videoUrl.split("/").pop();
        embedHtml = `<iframe src="https://player.vimeo.com/video/${vimeoId}?autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
      } else if (videoUrl.endsWith(".mp4")) {
        embedHtml = `<video controls autoplay><source src="${videoUrl}" type="video/mp4"></video>`;
      }

      videoContainer.innerHTML = embedHtml;
      popup.classList.add("active");
    });
  });

  closeBtn.addEventListener("click", () => {
    popup.classList.remove("active");
    videoContainer.innerHTML = "";
  });

  popup.addEventListener("click", (e) => {
    if (e.target === popup) {
      popup.classList.remove("active");
      videoContainer.innerHTML = "";
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-blocks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const playButtons = document.querySelectorAll(".play-button");
  const popup = document.getElementById("videoPopup");
  const videoContainer = document.getElementById("videoContainer");
  const closeBtn = document.querySelector(".video-popup .close-btn");

  playButtons.forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.stopPropagation();
      event.preventDefault();
      const videoUrl = btn.getAttribute("data-video");
      let embedHtml = "";

      if (videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be")) {
        embedHtml = `<iframe src="${videoUrl.replace("watch?v=", "embed/")}?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
      } else if (videoUrl.includes("vimeo.com")) {
        const vimeoId = videoUrl.split("/").pop();
        embedHtml = `<iframe src="https://player.vimeo.com/video/${vimeoId}?autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
      } else if (videoUrl.endsWith(".mp4")) {
        embedHtml = `<video controls autoplay><source src="${videoUrl}" type="video/mp4"></video>`;
      }

      videoContainer.innerHTML = embedHtml;
      popup.classList.add("active");
    });
  });

  closeBtn.addEventListener("click", () => {
    popup.classList.remove("active");
    videoContainer.innerHTML = "";
  });

  popup.addEventListener("click", (e) => {
    if (e.target === popup) {
      popup.classList.remove("active");
      videoContainer.innerHTML = "";
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-column"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const playButtons = document.querySelectorAll(".multicolumn-play-button");
  const popup = document.getElementById("multicolumnVideoPopup");
  const videoContainer = document.getElementById("multicolumnVideoContainer");
  const closeBtn = document.querySelector(".multicolumn-video-popup .multicolumn-close-btn");

  playButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const videoUrl = btn.getAttribute("data-video");
      let embedHtml = "";

      if (videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be")) {
        embedHtml = `<iframe src="${videoUrl.replace("watch?v=", "embed/")}?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
      } else if (videoUrl.includes("vimeo.com")) {
        const vimeoId = videoUrl.split("/").pop();
        embedHtml = `<iframe src="https://player.vimeo.com/video/${vimeoId}?autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
      } else if (videoUrl.endsWith(".mp4")) {
        embedHtml = `<video controls autoplay><source src="${videoUrl}" type="video/mp4"></video>`;
      }

      videoContainer.innerHTML = embedHtml;
      popup.classList.add("active");
    });
  });

  closeBtn.addEventListener("click", () => {
    popup.classList.remove("active");
    videoContainer.innerHTML = "";
  });

  popup.addEventListener("click", (e) => {
    if (e.target === popup) {
      popup.classList.remove("active");
      videoContainer.innerHTML = "";
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const playButtons = document.querySelectorAll(".press-play-button");
  const popup = document.getElementById("pressVideoPopup");
  const videoContainer = document.getElementById("pressVideoContainer");
  const closeBtn = document.querySelector(".press-video-popup .press-close-btn");

  playButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const videoUrl = btn.getAttribute("data-video");
      let embedHtml = "";

      if (videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be")) {
        embedHtml = `<iframe src="${videoUrl.replace("watch?v=", "embed/")}?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
      } else if (videoUrl.includes("vimeo.com")) {
        const vimeoId = videoUrl.split("/").pop();
        embedHtml = `<iframe src="https://player.vimeo.com/video/${vimeoId}?autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
      } else if (videoUrl.endsWith(".mp4")) {
        embedHtml = `<video controls autoplay><source src="${videoUrl}" type="video/mp4"></video>`;
      }

      videoContainer.innerHTML = embedHtml;
      popup.classList.add("active");
    });
  });

  closeBtn.addEventListener("click", () => {
    popup.classList.remove("active");
    videoContainer.innerHTML = "";
  });

  popup.addEventListener("click", (e) => {
    if (e.target === popup) {
      popup.classList.remove("active");
      videoContainer.innerHTML = "";
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
